import GetPincodeInfoEpic from './getPincodeInfo';

const LocationEpics = [
  GetPincodeInfoEpic,
];

export default LocationEpics;
